/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyDto } from './CompanyDto';
import {
    CompanyDtoFromJSON,
    CompanyDtoFromJSONTyped,
    CompanyDtoToJSON,
} from './CompanyDto';

/**
 * 
 * @export
 * @interface DescribeCompanyResponse
 */
export interface DescribeCompanyResponse {
    /**
     * 
     * @type {CompanyDto}
     * @memberof DescribeCompanyResponse
     */
    company: CompanyDto;
}

/**
 * Check if a given object implements the DescribeCompanyResponse interface.
 */
export function instanceOfDescribeCompanyResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "company" in value;

    return isInstance;
}

export function DescribeCompanyResponseFromJSON(json: any): DescribeCompanyResponse {
    return DescribeCompanyResponseFromJSONTyped(json, false);
}

export function DescribeCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeCompanyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'company': CompanyDtoFromJSON(json['company']),
    };
}

export function DescribeCompanyResponseToJSON(value?: DescribeCompanyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company': CompanyDtoToJSON(value.company),
    };
}

